import React from 'react'
import { IconComponent, PointerProgressComponent, ProgressComponent, PictureProgress, JumpHotAreaComponent, NumberComponent } from '../../components'
// import TemperatureNumber from './TemperatureNumber';
import TemperatureNumberWithRect from './TemperatureNumberWithRect'

const componentMap = (hasRectArea) => ({
  current: hasRectArea ? TemperatureNumberWithRect : NumberComponent,
  high: hasRectArea ? TemperatureNumberWithRect : NumberComponent,
  low: hasRectArea ? TemperatureNumberWithRect : NumberComponent,
  icon: IconComponent,
  pointer_progress: PointerProgressComponent,
  progress: ProgressComponent,
  image_progress: PictureProgress,
  jumpable: JumpHotAreaComponent
})

class Temperature extends React.Component {
  static renderLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]
    Component.renderLayer({ childKey, ...restArgs })
  }

  static removeLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]

    if (Component && Component.removeLayer) {
      Component.removeLayer({ childKey, ...restArgs })
    }
  }

  render() {
    const { childKey, propMap } = this.props
    const prop = propMap[childKey] || {}
    const { hasRectArea } = prop
    const Component = componentMap(hasRectArea)[childKey]
    const allProps = { ...this.props, ...prop }

    return <div className="control-container">{Component && <Component {...allProps} />}</div>
  }
}

export default Temperature
